import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=cd27e60c&scoped=true&"
import script from "./DocumentPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=cd27e60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd27e60c",
  null
  
)

export default component.exports